export const WELCOME_TEXT = "activation.home.title.with.name";
export const USERS_ICON_TOOLTIP = "activation.home.header.users.tooltip";
